import { HttpInterceptorFn } from '@angular/common/http';
import { AppSettings } from '../app.settings';
import { catchError } from 'rxjs/internal/operators/catchError';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { throwError } from 'rxjs/internal/observable/throwError';

export const jwtInterceptor: HttpInterceptorFn = (req, next) => {

  const apiEndpoint: string = AppSettings.settings.apiServer.backend;
  const router = inject(Router); 

  let token = localStorage.getItem("auth_token");

  const isApiUrl = req.url.startsWith(apiEndpoint);
  if (token && isApiUrl) {
      req = req.clone({
          setHeaders: { Authorization: `Bearer ${token}` }
      });
  }

  return next(req).pipe(
    catchError((error) => {
      if (error.status === 401) {
        // Umleitung zur Login-Seite
        router.navigate(['/login']);
      }
      return throwError(() => error);
    })
  );
  
};
